import React from 'react';
import { REVIEWS_PER_PAGE } from '../../type';

const ReviewsListSkeleton: React.FC = () => {
    return (
        <>
            {Array.from({ length: REVIEWS_PER_PAGE }).map((_, index) => (
                <div
                    key={index}
                    className="flex flex-col flex-[1_1_calc(33.333%-14px)] box-border bg-primary-light p-5 rounded-2xl border border-light-gray shadow-[0_7px_9px_rgba(141,141,141,0.10),0_4px_13px_rgba(141,141,141,0.08)] animate-pulse"
                >
                    <div className="flex justify-between items-center">
                        <div className="flex gap-2.5">
                            <div className="w-[36px] h-[36px] bg-gray-200 rounded-[6px]"></div>
                            <div className="reviewer-rating">
                                <div className="h-[18px] bg-gray-200 rounded w-32 mb-1"></div>
                                <div className="h-[15px] bg-gray-200 rounded w-20"></div>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="h-3 bg-gray-200 rounded w-16"></div>
                            <div className="h-3 bg-gray-200 rounded w-12"></div>
                        </div>
                    </div>

                    <div className="my-5 space-y-2">
                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                        <div className="h-4 bg-gray-200 rounded w-4/5"></div>
                        <div className="h-4 bg-gray-200 rounded w-3/5"></div>
                    </div>

                    <div
                        className="mt-auto flex justify-center pt-5 border-t"
                        style={{ borderColor: 'var(--light-gray, #E4E4E4)' }}
                    >
                        <div className="h-10 bg-gray-200 rounded-full w-32"></div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default ReviewsListSkeleton;
